export const BackgroundIllustration = () => {
  return <div id="background-illustration"></div>;
};
